import * as React from "react";
import styled from "styled-components"

export default function MarginBox({ height = 0 ,width = 1 }) {

    return(
        <Margin
            height={height}
            width={width}
        />
    )
}

const Margin = styled.div`
    max-width: 100%;
    display: block;
    width:${props => `${props.width}px`};
    height:${props => `${props.height}px`};
`;


